import React from "react";
import _ from "lodash";
import "./VideoCarousel.scss";
// import Dropdown, { DropdownTrigger, DropdownContent } from "react-simple-dropdown";
// import chevronBlueDown from "../../../shared/images/selectArrowBlue.png";
// import Slider from 'react-slick';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

library.add(faArrowLeft, faArrowRight);

class VideoCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentVideo: 1,
    };
  }

  componentDidUpdate() {
    const vid = document.getElementsByTagName("video")[0];
    if (vid !== undefined) {
      vid.removeEventListener("ended", this.onVideoEnded, false);
      vid.addEventListener(
        "ended",
        () => {
          this.onVideoEnded();
        },
        false,
      );
    }
  }

  onVideoEnded() {
    const { currentVideo } = this.state;
    const { children } = this.props;

    if (currentVideo < children.length) {
      this.onNext();
    }
  }

  onNext() {
    this.setState((s) => {
      s.currentVideo++;
      return s.currentVideo;
    });
  }

  onPrev() {
    this.setState((s) => {
      s.currentVideo--;
      return s.currentVideo;
    });
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    const { children } = this.props;
    const { currentVideo } = this.state;
    const goRight = currentVideo > 1 ? true : false;
    const goLeft = currentVideo < children.length ? true : false;

    return (
      <div className="video-carousel">
        {goRight ? (
          <span className="arrow-wrapper">
            <FontAwesomeIcon
              onClick={() => {
                this.onPrev();
              }}
              className="arrow prev"
              icon="arrow-left"
              size="3x"
            />
          </span>
        ) : null}

        {children[currentVideo - 1]}

        {goLeft ? (
          <span className="arrow-wrapper next">
            <FontAwesomeIcon
              onClick={() => {
                this.onNext();
              }}
              className="arrow next"
              icon="arrow-right"
              size="3x"
            />
          </span>
        ) : null}
      </div>
    );
  }
}

export default VideoCarousel;
